var map = {
	"./ca_ES": [
		"cd1c",
		"lang0"
	],
	"./ca_ES.json": [
		"cd1c",
		"lang0"
	],
	"./es_ES": [
		"b831",
		"lang2"
	],
	"./es_ES.json": [
		"b831",
		"lang2"
	],
	"./pt_PT": [
		"bfc5",
		"lang4"
	],
	"./pt_PT.json": [
		"bfc5",
		"lang4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;